import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAddEmailTemplatePage = React.lazy(() => import(/* webpackChunkName: "AdminAddEmailTemplate" */ './Page'));
export const AdminAddEmailTemplate = () => (React.createElement(Page, { title: "Add Email Template" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminAddEmailTemplatePage, null)))));
